<template>
  <div class="upload-files">
    <el-upload
      v-if="!imageUrl"
      v-loading="loading1"
      ref="upload"
      action=""
      class="avatar-uploader"
      :show-file-list="false"
      :http-request="handleChange"
      :before-upload="beforeAvatarUpload"
      :limit="1"
    >
      <!--      <el-image-->
      <!--        :src="defaultImage"-->
      <!--        :style="{ width: previewImgWidth, height: previewImgHeight }"-->
      <!--      ></el-image>-->
      <slot>
        <div
          class="default-upload"
          :style="{ width: previewImgWidth, height: previewImgHeight }"
        >
          <i class="el-icon-plus"></i>
          <span>点击上传</span>
        </div>
      </slot>
    </el-upload>
    <div
      class="upload-files-box"
      v-else
      v-loading="loading"
      element-loading-text="拼命解析中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.4)"
      :style="{ width: previewImgWidth, height: previewImgHeight }"
    >
      <el-image
        :class="isPersonal ? 'b5' : ''"
        :src="imageUrl"
        fit="cover"
        class="upload-files-box-image"
        :preview-src-list="[imageUrl]"
      ></el-image>
      <span class="delete-icon" @click="deleteImage()"
        ><i class="el-icon-circle-close"></i
      ></span>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <el-image width="100%" :src="imageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { getShortToken, uploadFile } from "@/views/commonApi";

export default {
  name: "UploadFiles",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    shortToken: {
      type: String,
      default: "",
    },

    isPersonal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },

    uploadTxt: {
      type: String,
      default: "上传图片",
    },
    defaultImage: {
      type: String,
      default: require("@/assets/img/default_photo3.png"),
    },
    previewImgWidth: {
      type: String,
      default: "1.24rem",
    },
    previewImgHeight: {
      type: String,
      default: "0.56rem",
    },
    maxSize: {
      type: Number,
      default: 5,
    },
    isCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading1: false,
      imageUrl: "",
      dialogVisible: false,
      saveFileId: "",
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      // thi/s.$nextTick(() => {
      if (!newVal || newVal !== this.saveFileId) {
        this.setInitValue(newVal);
      }

      // });
    },
  },
  created: function () {
    // // console.log("创建 ：", this.value);
    if (this.shortToken) {
      if (this.value) {
        this.imageUrl =
          process.env.VUE_APP_BASE_PATH +
          process.env.VUE_APP_REMOTE_API +
          "/file/sys-file/download/public?fileId=" +
          this.value +
          "&credit=" +
          this.shortToken;
      }
    } else {
      this.setInitValue(this.value);
    }
  },
  methods: {
    deleteImage() {
      this.imageUrl = "";
      this.$emit("change", "");
    },
    setInitValue(value) {
      if (!value) {
        this.value = "";
        this.imageUrl = "";
        return;
      }
      this.getShortImageToken(value);
      // this.$emit("change", this.value);
    },
    // 图片上传之前的
    beforeAvatarUpload(file) {
      // console.log("file", file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < this.maxSize;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或者 PNG 格式!");
      }
      if (!isLt5M) {
        this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`);
      }
      return isJPG && isLt5M;
    },
    handleChange(file, fileList) {
      this.uploadFiles(file);
    },
    uploadFiles(file) {
      // console.log("file", file);
      let files = file.file;
      if (this.isCheck) {
        let formData = new FormData();
        formData.append("file", files);
        this.loading1 = true;
        // uploadCarImage(formData)
        uploadFile(formData)
          .then((res) => {
            this.loading1 = false;
            if (res.code === 200) {
              this.getBase64(files).then((resBase64) => {
                this.imageUrl = resBase64;
              });
              this.saveFileId = res.data.fileId;
              this.$emit("change", res.data.fileId);
            }
          })
          .catch((err) => {
            this.loading1 = false;
          });
      } else {
        let formData = new FormData();
        formData.append("file", files);
        this.loading1 = true;
        // uploadCarImage(formData)
        uploadFile(formData)
          .then((res) => {
            this.loading1 = false;
            this.$refs.upload.clearFiles();
            if (res.code === 200) {
              this.getShortImageToken(res.data.fileId);
              this.saveFileId = res.data.fileId;
              this.$emit("change", res.data.fileId);
            }
          })
          .catch((err) => {
            this.loading1 = false;
            this.$refs.upload.clearFiles();
            // console.log(err);
          });
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file); //开始转
        reader.onload = function () {
          fileResult = reader.result;
        }; //转 失败
        reader.onerror = function (error) {
          reject(error);
        }; //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    getShortImageToken(fileId) {
      getShortToken().then((res) => {
        if (res.code === 200) {
          this.imageUrl =
            process.env.VUE_APP_BASE_PATH +
            process.env.VUE_APP_REMOTE_API +
            "/file/sys-file/download/public?fileId=" +
            fileId +
            "&credit=" +
            res.data;
        }
        // console.log("res", this.imageUrl);
      });
    },
  },
};
</script>
<style lang="scss">
.upload-files {
  //display: inline-block;

  .el-upload--picture-card {
    border: none;
    width: auto;
    height: auto;
    background: none;
    border-radius: 0;
    line-height: 1;
  }
}
</style>
<style lang="scss" scoped>
.upload-files {
  .default-upload {
    background: #ffffff;
    border-radius: 0.04rem;
    border: 0.01rem dashed #dddee1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 0.2rem;
      color: #565a60;
    }
    span {
      font-weight: 400;
      font-size: 0.12rem;
      color: #565960;
      padding-top: 0.05rem;
    }
  }
  .upload-files-box {
    position: relative;
    border-radius: 0.04rem;
    border: 0.01rem solid #ffffff;
    .upload-files-box-image {
      border-radius: 0.04rem;
      width: 100%;
      height: 100%;
    }
    .b5 {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
    .delete-icon {
      position: absolute;
      right: -0.1rem;
      top: -0.16rem;
      font-size: 0.2rem;
      color: red;
      cursor: pointer;

      &:hover {
        color: #b64040;
      }
    }
  }
}
</style>
